module.exports = __webpack_public_path__ + "media/images/top/top_pickup_company_04-d14fe33c27534c066ed78ca25fe58d62.png";